module.exports = __webpack_public_path__ + "static/media/api.2022e37e.png";